import { reduceResetInteractions } from '../../../../core/components/interactions-state-helpers/reducers/reset-reducers.js';
import { useSynchronizedSelection } from '../../../../core/components/shared-chart-interactions/hooks/useSynchronizedSelection.js';
import type { RelativeAbsolutePosition } from '../../../../core/types/pointer-events.js';
import { useSetState } from '../../../hooks/store/selectors.js';
import { useChartInteractions } from '../../../hooks/useChartInteractions.js';
import { useInfiniteZoomConfig } from '../../../hooks/useInfiniteZoomConfig.js';
import { useXScales } from '../../../hooks/useXScale.js';

/**
 * Returns a method to reset chart interactions, providing the possibility of
 * setting last mouse position in order to keep showing the crosshair and tooltip.
 */
export const useResetInteractions = () => {
  const setState = useSetState();

  const { onZoomChange } = useChartInteractions();
  const { initialScale } = useXScales();
  const infiniteZoomEnabled = useInfiniteZoomConfig();
  const { resetSelectionState } = useSynchronizedSelection();

  const domain = initialScale.domain();

  return (lastMousePosition?: RelativeAbsolutePosition) => {
    setState(reduceResetInteractions(infiniteZoomEnabled, lastMousePosition));
    resetSelectionState?.();

    onZoomChange?.(domain[0], domain[1], 'reset');
  };
};
